import { GulliesAsset } from '@types';
import { useDrainsStore } from './useDrainsStore';

export const useDrainsPayload = () => {
  const { get } = useDrainsStore();
  const can_be_contacted =
    get('wantConfirmationEmail').toLowerCase() === 'yes' ? true : false;
  const can_back_office_contact =
    get('contactUserOption').toLowerCase() === 'yes' ? true : false;

  const assetDetails = get('assetDetails') as GulliesAsset;

  const payload = {
    ChannelObject: {
      channel: 'Online',
      platform: 'React',
      session_id: get('sessionId'),
    },
    ServiceLocationObject: {
      address_line_1: get('serviceLocationDetails.address_line_1'),
      address_line_2: get('serviceLocationDetails.address_line_2'),
      town_city: get('serviceLocationDetails.town_city'),
      county: get('serviceLocationDetails.county'),
      postcode: get('serviceLocationDetails.postcode'),
      country: get('serviceLocationDetails.country'),
      UPRN: get('serviceLocationDetails.UPRN'),
      USRN: get('serviceLocationDetails.USRN'),
      latitude: Number(get('serviceLocationDetails.latitude')),
      longitude: Number(get('serviceLocationDetails.longitude')),
      easting: get('serviceLocationDetails.easting'),
      northing: get('serviceLocationDetails.northing'),
      additional_details: get('issueLocationMoreInfo'),
      is_commercial: get('serviceLocationDetails.is_commercial'),
      is_within_borough: get('serviceLocationDetails.is_within_borough'),
      asset: {
        asset_id: assetDetails?.central_asset_id,
        layer_id: 16,
      },
    },
    ReporterObject: {
      can_back_office_contact,
      can_be_contacted,
      contact_id: null,
      ...(can_be_contacted || can_back_office_contact
        ? {
            name: {
              first_name: get('userDetails.firstName'),
              last_name: get('userDetails.lastName'),
            },
            contact_details: {
              email_address: get('userDetails.email'),
              ...(can_back_office_contact
                ? { phone_number: get('userDetails.phoneNumber') }
                : {}),
            },
          }
        : {}),
    },
    ReportObject: {
      issue_type: get('issueType'),
      flooding_affecting_type:
        get('floodType') === '' ? undefined : get('floodType'),
      more_details: get('tellUsMoreDetails'),
    },
    ...(get('uploadedImagesBlob').length > 0 && {
      FileCollectionObject: {
        external: true,
        files: get('uploadedImagesBlob').map((imageblob) => ({
          path: imageblob.blob_uri,
          name: imageblob.filename,
        })),
      },
    }),
  };

  return payload;
};
